import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Col from 'react-bootstrap/lib/Col';
import queryString from 'query-string';
import cx from 'classnames';

// Actions.
import * as AuthActions from 'actions/AuthActions';
import * as ConfigActions from 'actions/ConfigActions';
import * as ProfileActions from 'actions/ProfileActions';

// Utils.
import { isWebviewApp } from 'utils';

// Styles.
import styles from './styles.module.scss';

@withRouter
@connect(
  dispatch => ({
    authActions: bindActionCreators(AuthActions, dispatch),
  })
)
export default class AuthContainer extends Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    content: PropTypes.element,
    children: PropTypes.element,
  };

  componentWillMount() {
    if (this.props.location) {
      const query = queryString.parse(this.props.location.search);
      if (query.auth_token !== undefined) {
        this.props.authActions.loginToken(query.auth_token);
      }
    }
  }

  componentDidMount() {
  }

  render() {
    const {
      content,
      children,
    } = this.props;

    const isWebviewAppStatus = isWebviewApp();
    return (
      <div className={cx(styles.authWrapper, { [styles.isWebView]: isWebviewAppStatus })}>
        <div id="content" className={styles.content}>
          <div className="container-fixed">
            <Grid container>
              <div className={cx(styles.contentWrapper, { [styles.isWebView]: isWebviewAppStatus })}>
                <Col xs={12} md={12}>
                  {content || children}
                </Col>
              </div>
            </Grid>
          </div>
        </div>
      </div>
    );
  }

}
